import { MatDialogConfig } from '@angular/material/dialog';

import { PersonalPlanUpsellDialogData } from '../ui/dialogs/personal-plan-upsell-dialog/typings';
import { PlanLimitEvent } from './typings';

const BASE_PERSONAL_PLAN_UPSELL_DIALOG_CONFIG = {
  width: '520px',
  maxWidth: 'calc(100vw - 2rem)',
  autoFocus: 'dialog',
  restoreFocus: true,
  role: 'dialog',
  panelClass: 'modal-panel',
} satisfies MatDialogConfig<PersonalPlanUpsellDialogData>;

export function resolvePlanLimitUpsellDialogConfig(event: PlanLimitEvent): MatDialogConfig<PersonalPlanUpsellDialogData> {
  if (event.limit === 'wheels') {
    return { ...BASE_PERSONAL_PLAN_UPSELL_DIALOG_CONFIG, data: { state: 'wheelLimitReached' } };
  }

  if (event.context === 'saveSession') {
    return { ...BASE_PERSONAL_PLAN_UPSELL_DIALOG_CONFIG, data: { state: 'additionalSessionRejected' } };
  }

  const hasOneSessionRemaining = event.maximum !== undefined && event.used === event.maximum - 1;
  return {
    ...BASE_PERSONAL_PLAN_UPSELL_DIALOG_CONFIG,
    data: { state: hasOneSessionRemaining ? 'oneSessionRemaining' : 'sessionLimitReached' },
  };
}
